import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "650",
  height: "101",
  viewBox: "0 0 650 101",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M0 85.9744L54.1667 83.6012C108.333 81.0488 216.667 76.571 325 62.1076C433.333 47.9128 541.667 23.7325 595.833 11.9558L650 0V100.304H595.833C541.667 100.304 433.333 100.304 325 100.304C216.667 100.304 108.333 100.304 54.1667 100.304H0V85.9744Z",
      fill: "#FCFAF8"
    }, null, -1)
  ])))
}
export default { render: render }